module.exports = __webpack_public_path__ + "img/logo-lecordonbleu-dark.3d0cc082.svg";